import { call, put, takeLatest, select } from "redux-saga/effects";
import { hallsAPI } from "../api/api";
import { HallsActionTypes } from "../actions/actionTypes";
import { hallsStoreSelectors } from "../store/store";
import { AddressUtils } from "../../../utils/addressUtils";

function* updateCreatingHall(action) {
    try {
        const subsidiaries = yield select(() =>
            hallsStoreSelectors.subsidiaryList()
        );

        const address = AddressUtils.addressFromForm({
            formValues: action.payload.values,
            subsidiaries
        });

        if (
            action.payload.values.address_line_1 &&
            action.payload.values.address_line_1.length > 0 &&
            action.payload.values.address_line_2 &&
            action.payload.values.address_line_2.length > 0 &&
            action.payload.values.subsidiary
        ) {
            const previousAddress = yield select(() =>
                hallsStoreSelectors.mapCoordinates()
            );

            if (!previousAddress || previousAddress.address !== address) {
                const addressInfo = yield call(() =>
                    hallsAPI.searchOSMAddress(address)
                );

                if (
                    addressInfo &&
                    addressInfo.data[0].lat &&
                    addressInfo.data[0].lon
                ) {
                    yield put({
                        type: HallsActionTypes.UPDATE_MAP_COORDINATES,
                        payload: {
                            lat: Number(addressInfo.data[0].lat),
                            lon: Number(addressInfo.data[0].lon),
                            address
                        }
                    });
                }
            }
        }

        /*yield put({
            type: HallsActionTypes.UPDATE_SUGGESTIONS,
            payload: {
                address
            }
        });*/
    } catch (e) {}
}

export function* updateCreatingHallWatcher() {
    yield takeLatest(HallsActionTypes.UPDATE_CREATING_HALL, updateCreatingHall);
}

function* updateSuggestions(action) {
    try {
        const request = yield call(() =>
            hallsAPI.searchOSMAddress(action.payload.address)
        );

        const subsidiaries = yield select(() =>
            hallsStoreSelectors.subsidiaryList()
        );

        const creatingHall = yield select(() =>
            hallsStoreSelectors.creatingHall()
        );

        const results = AddressUtils.filterSuggestions({
            suggestions: request.data,
            subsidiaries,
            formValues: creatingHall.values
        });

        yield put({
            type: HallsActionTypes.UPDATE_SUGGESTIONS_SUCCESS,
            payload: {
                results
            }
        });
    } catch (e) {
        yield put({
            type: HallsActionTypes.UPDATE_SUGGESTIONS_FAIL,
            payload: e
        });
    }
}

export function* updateSuggestionsWatcher() {
    yield takeLatest(HallsActionTypes.UPDATE_SUGGESTIONS, updateSuggestions);
}

function* mapClick(action) {
    try {
        const request = yield call(() =>
            hallsAPI.reverseOSMAddress(
                action.payload.latlng.lat,
                action.payload.latlng.lon
            )
        );

        yield put({
            type: HallsActionTypes.MAP_CLICK_SUCCESS,
            payload: request.data
        });
    } catch (e) {
        yield put({
            type: HallsActionTypes.MAP_CLICK_FAIL,
            payload: e
        });
    }
}

export function* mapClickWatcher() {
    yield takeLatest(HallsActionTypes.MAP_CLICK, mapClick);
}
